<template>
  <div>
    <Header modeType="2" />
    <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">千橙智能收银</div>
        <div class="line" />
        <div class="desc">
          服务于有收银场景的实体门店，为门店提供收银营销一体化工具
        </div>
        <div class="btn-wrap">
          <div
            class="btn1"
            @click="openLoginModal"
          >免费试用</div>
          <div
            class="btn"
            @click="openModal"
          >立即咨询</div>
        </div>
      </div>
    </div>
    <div class="distribution">
      <div class="sk-block-title">
        <div class="title">实体门店经营痛点</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/images/QcCashier/content1.png" alt="">
          <span class="content_title">商品不好管</span>
          <p>店铺商品多、商品议价场景多人工记价乱</p>
        </div>
        <div class="item">
          <img src="@/assets/images/QcCashier/content2.png" alt="">
          <span class="content_title">交易结算慢</span>
          <p>日均开单量大、传统人工结算排队久交易不留痕</p>
        </div>
        <div class="item">
          <img src="@/assets/images/QcCashier/content3.png" alt="">
          <span class="content_title">营销不会做</span>
          <p>老客易流失、新客不转化想做运营无从下手</p>
        </div>
        <div class="item">
          <img src="@/assets/images/QcCashier/content4.png" alt="">
          <span class="content_title">数据不清晰</span>
          <p>对账费时费力、无法分析经营状况、更换设备数据易丢失</p>
        </div>
      </div>
    </div>
    <div class="sharp">
      <!-- <div class="sk-block-title">
        <div class="title">“三大利器”助力开展分享裂变</div>
      </div> -->
      <div class="content">
        <div class="right">
          <div class="sub-title" style="margin-top: 48px;">多元商品管理</div>
          <!-- <div class="sub-content">多种商品建档方式，且支持多种类型商品管理，帮助店铺高效管理商品资产</div> -->
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              40万+云端商品库，支持商品一键添加
            </div>
          </div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              实物商品、称重商品、多规格商品标准化建档
            </div>
          </div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              支持商品议价、订单议价等多场景改价
            </div>
          </div>
        </div>
        <img src="@/assets/images/QcCashier/sharp_bg.png" alt="">
      </div>
    </div>
    <div class="coreFun">
      <!-- <div class="sk-block-title">
        <div class="title">核心功能</div>
      </div> -->
      <div class="content">
        <img class="content_bg" src="@/assets/images/qcerpsystem/coreFun_bg.png" alt="">
        <div class="left" style="margin-left: 69px;">
          <div class="sub-title" style="margin-top: 67px;">高效快捷的开单收银</div>
          <!-- <div class="sub-content">全渠道订单协同管理，数据云端化，助力经营提效</div> -->
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              支持点选、扫码、AI识别，快速加购商品
            </div>
          </div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              根据商品售卖情况智能调整商品排序，快速选择快速开单
            </div>
          </div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              商品条码，收款条码自动识别，连续扫码轻松收银
            </div>
          </div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              优惠自动计算，1秒出票快速结算
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sharp">
      <!-- <div class="sk-block-title">
        <div class="title">“三大利器”助力开展分享裂变</div>
      </div> -->
      <div class="content">
        <div class="right">
          <div class="sub-title" style="margin-top: 48px;">精细化的营销场景</div>
          <!-- <div class="sub-content">多种商品建档方式，且支持多种类型商品管理，帮助店铺高效管理商品资产</div> -->
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              开单即会员，门店会员一键添加
            </div>
          </div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              线上线下会员权益全面打通，多渠道统一营销
            </div>
          </div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              积分、 会员储值、会员价等多种会员专属权益
            </div>
          </div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              满减满折、代金券、积分抵扣等丰富的场景化营销活动
            </div>
          </div>
        </div>
        <img src="@/assets/images/QcCashier/sharp_bg1.png" alt="">
      </div>
    </div>
    <div class="coreFun" style="background-color: #FFFFFF;">
      <!-- <div class="sk-block-title">
        <div class="title">核心功能</div>
      </div> -->
      <div class="content">
        <img class="content_bg" src="@/assets/images/QcCashier/coreFun_bg1.png" alt="">
        <div class="left" style="margin-left: 69px;">
          <div class="sub-title" style="margin-top: 67px;">经营情况精准掌控</div>
          <!-- <div class="sub-content">全渠道订单协同管理，数据云端化，助力经营提效</div> -->
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              报表统计多样化，经营情况一目了然
            </div>
          </div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              数据分析精准化，助力门店运营决策
            </div>
          </div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/QcCashier/checked.png" alt="">
            </div>
            <div class="content-box-right">
              经营报表多端互通，数据实时同步
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="scene scene1">
      <div class="sk-block-title1">
        <div class="title1">更多场景功能介绍</div>
        <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
      </div>
      <div class="content"></div>
    </div>
    <div class="scene scene2">
      <div class="content1">
        <div class="sk-block-title1" style="padding-top: 34px;width: 1200px;display: flex;flex-direction: column;background-color:#fff;align-items: center;">
          <div class="title1">全面兼容，满足不同经营需求</div>
          <div class="sub-title1" style="width: 800px;height: 56px;font-size: 20px;font-family: PingFangSC, PingFang SC;font-weight: 400;color: #333333;line-height: 28px;">开店所需的收银一体机、小票机、扫码枪、钱箱、打印机、摄像头等设备已为您全面兼容。蓝牙、LAN、USB接口、WIFI、移动数据网络、串口，满足所有业态的需求。</div>
        </div>
        <div class="content_box">
            <div class="box_item">
                <img src="@/assets/images/QcCashier/box1.png" alt="">
                <p>D2一体机</p>
            </div>
            <div class="box_item">
                <img src="@/assets/images/QcCashier/box2.png" alt="">
                <p>小票打印机</p>
            </div>
            <div class="box_item">
                <img src="@/assets/images/QcCashier/box3.png" alt="">
                <p>扫码枪</p>
            </div>
            <div class="box_item">
                <img src="@/assets/images/QcCashier/box4.png" alt="">
                <p>扫码盒</p>
            </div>
            <div class="box_item">
                <img src="@/assets/images/QcCashier/box5.png" alt="">
                <p>价签/标签</p>
            </div>
            <div class="box_item">
                <img src="@/assets/images/QcCashier/box6.png" alt="">
                <p>摄像头</p>
            </div>
            <div class="box_item">
                <img src="@/assets/images/QcCashier/box7.png" alt="">
                <p>钱箱</p>
            </div>
        </div>
      </div>
    </div>
    <div class="tool">
        <div class="sk-block-title1">
          <div class="title1">深耕行业，提供更匹配行业的收银工具</div>
        </div>
        <div class="content">
            <div class="tool_left">
                <div class="left_item" :class="{'left_item1':tooItem=='1'}" @click="checkBg('1')">标准版</div>
                <div class="left_item" :class="{'left_item1':tooItem=='2'}" @click="checkBg('2')">家电版</div>
                <div class="left_item" :class="{'left_item1':tooItem=='3'}" @click="checkBg('3')">商超版</div>
                <div class="left_item" :class="{'left_item1':tooItem=='4'}" @click="checkBg('4')">餐饮版</div>
            </div>
            <div class="tool_right">
                <img v-if="tooItem=='1'" src="@/assets/images/QcCashier/tool1.png" alt="">
                <img v-if="tooItem=='2'" src="@/assets/images/QcCashier/tool2.png" alt="">
                <img v-if="tooItem=='3'" src="@/assets/images/QcCashier/tool3.png" alt="">
                <img v-if="tooItem=='4'" src="@/assets/images/QcCashier/tool4.png" alt="">
            </div>
        </div>
    </div>
    <div class="case" style="background-color: #FFFFFF;">
      <div class="sk-block-title1">
        <div class="title1">全场景一站式综合支付解决方案</div>
      </div>
      <div class="content">
        <img src="@/assets/images/QcCashier/case_bg.png" alt="">
      </div>
    </div>
    <div class="custom">
      <div class="sk-block-title1">
        <div class="title1">客户案例</div>
      </div>
      <div class="content">
        <el-carousel :autoplay="false" :interval="5000" arrow="always">
          <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/QcCashier/custom_bg1.png" alt="">
            </div>
          </el-carousel-item>
          <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/QcCashier/custom_bg2.png" alt="">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <Contact :infoSources="'汇通数科官网-千橙收银'" />
    <TryModal v-if="visible" :visible="visible" info-sources="社群分销" @cancel="modalClose" />
    <LoginModal
            v-if="showLogin"
            :showLogin="showLogin"
            @cancel="loginModalClose"
            :isLogin="isLogin"
            :selectValue="'2'"
        />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Contact from '@/components/Contact'
import metaInfo from '@/common/util/metaInfo'
import TryModal from '@/components/TryModal'
import LoginModal from '@/components/LoginModal'

export default {
  metaInfo: metaInfo.QcCashier,
  components: {
    Header,
    Footer,
    TryModal,
    Contact,
    LoginModal
  },
  data() {
    return {
      visible: false,
      toolBg: require('@/assets/images/QcCashier/tool1.png'),
      tooItem: '1',
      showLogin:false,//是否展示注册弹框
      isLogin:false,//是否注册
    }
  },
  mounted() {

  },
  methods: {
    // 是否需要显示二维码
    openLoginModal() {
        this.showLogin = true
        this.isLogin = false
    },
    loginModalClose(data) {
        this.showLogin = data;
    },
    checkBg(item) {
      this.tooItem = item
      this.toolBg = '@/assets/images/QcCashier/tool' + item + '.png'
    },
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ i.el-icon-arrow-left {
    font-size: 35px;
    font-weight: 600;
}
/deep/ i.el-icon-arrow-right{
    font-size: 35px;
    font-weight: 600;
}
/deep/ button.el-carousel__arrow.el-carousel__arrow--left,button.el-carousel__arrow.el-carousel__arrow--right {
    width: 50px;
    height: 86px;
    border-radius: 0px;
    background-color: rgba(0,0,0,.4);
}
/deep/ button.el-carousel__arrow.el-carousel__arrow--right {
    width: 50px;
    height: 86px;
    border-radius: 0px;
    background-color: rgba(0,0,0,.4);
}
.custom{
    height:662px;
        background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items:center;
    .content{
        width: 1200px;
        height:439px;
        margin: 0 auto;
        // padding: 53px 0;
        text-align: left;
        background: rgba(255,255,255,.5);
        // background: #FFFFFF;
        // opacity: 0.55;
        // border-radius: 8px;
        margin-top: 42px;
        /deep/ .el-carousel__container {
            position: relative;
            height: 439px;
        }
        .custom_item{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            // padding:0 150px;
            img{
                width: 1200px;
                height: 439px;
            }
        }
    }
}
.case{
    background: #F8FBFF;
    .content{
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            width: 1171px;
            height:397px;
        }
    }
}
.content_title{
    height: 30px;
    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
}
.content-center {
    background-color:#FFFFFF;
    ul,
    li {
    list-style: disc;
    }
  // .banner {
  //   background: url("~@/assets/images/community/community_banner.png") no-repeat center;
  //   min-width: 1200px;
  //   .btn-wrap {
  //     width: 1200px;
  //     margin: 0 auto;
  //     padding: 309px 0 53px;
  //     .btn {
  //       width: 200px;
  //       height: 58px;
  //       line-height: 58px;
  //       border-radius: 6px;
  //       border: 1px solid #FFFFFF;
  //       font-size: 22px;
  //       color: #FFFFFF;
  //       cursor: pointer;
  //     }
  //   }
  // }
  .banner {
    background: url("~@/assets/images/qcerpsystem/qcerpsystem_banner.png") no-repeat center;
    background-size: 100% 100%;
    min-width: 1200px;
    .content {
      width: 1200px;
      margin: 0 auto;
      padding: 53px 0;
      text-align: left;
      .banner-title {
        font-size: 48px;
        color: #FFFFFF;
        line-height: 55px;
      }
      .line {
        width: 100px;
        height: 6px;
        background: #28DAFB;
        margin: 16px 0 31px;
      }
      .desc {
        width: 512px;
        height: 101px;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 28px;
      }
      .btn-wrap {
        display: flex;
        .btn {
          width: 200px;
          height: 58px;
          line-height: 58px;
          border-radius: 6px;
          border: 1px solid #FFFFFF;
          font-size: 22px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
          margin-left:20px;
        }
        .btn1 {
          width: 200px;
          height: 58px;
          line-height: 58px;
          background: #3986FF;
          border-radius: 6px;
          font-size: 22px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
        //   margin-left:20px;
        }
      }
    }
  }
  .distribution {
    background: #FFFFFF;
    .content {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0 124px 0;
      .item {
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
        width: 238px;
        height: 340px;
        // background: #FFFFFF;
        // box-shadow: 0px 0px 10px 0px rgba(221, 221, 221, 0.5);
        // border-radius: 6px;
        justify-content: center;
        align-items: center;
        padding: 28px 28px;
        // background: fixed url("~@/assets/images/qcerpsystem/content_bg.png") no-repeat center;
        // background-size: 100% 100%;
        img {
          width: 144px;
          height: 144px;
        }
        span {
          margin-top: 12px;
          height: 28px;
          font-size: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 28px;
        }
        div {
          margin-top: 12px;
          width: 40px;
          height: 6px;
          background: #2F81E8;
        }
        p {
          margin-top: 6px;
          width: 219px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
      }
    }
  }
  .shop {
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    .content {
      width: 1200px;
      height:503px;
      text-align: center;
      margin: 17px 0 51px 0;
      background: url("~@/assets/images/qcerpsystem/shop_bg.png") no-repeat center;
      background-size: 1200px 503px;
      .content_left{
        width: 300px;
        padding: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        float: right;
        .content_box{
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: 40px;
           .content_box_left{
                width: 24px;
                img{
                    width: 24px;
                    height: 24px;
                }
           }
           .content_box_right{
                width: 200px;
                text-align: left;
                // height: 33px;
                font-size: 20px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 33px;
           }
        }
     }
    }
  }
  .sub-title {
    font-size: 30px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
    margin-bottom:20px;
      }
      .sub-content {
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 36px;
      }
  .sharp {
    background: #F8FBFF;
    .content {
      width: 1159px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 57px 0 60px 0;
      .right {
        width: 578px;
        text-align: left;
      }
      img{
        width: 612px;
        height: 368px;
      }

    }
  }
  .content-box{
      display: flex;
      flex-direction: row;
      margin-top: 52px;
      .content-box-left{
          width:24px;
          display: flex;
          align-items: center;
          img{
              width: 24px;
              height: 24px;
          }
      }
      .content-box-right{
        //   width: 383px;
          height: 28px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 28px;
          margin-left:15px;
      }

  }
  .coreFun {
    padding-bottom: 73px;
    background: #FFFFFF;
    .content {
      display: flex;
      justify-content: space-between;
      width: 1179px;
      margin: 60px auto 0;
      .left {
        width: 600px;
        text-align: left;
      }
      .content_bg{
        width: 612px;
        height: 368px;
      }

    }
  }
  .scene1{
    background: url("~@/assets/images/QcCashier/scene_bg.png") no-repeat center;
    background-size:100% 100%;
  }
  .scene2{
    background: url("~@/assets/images/QcCashier/scene_bg2.png") no-repeat center;
    background-size:100% 100%;
  }
  .tool{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #F8FBFF;
    // background: url("~@/assets/images/QcCashier/tool_bg.png") no-repeat center;
    // background-size:100% 100%;
    .content {
      width: 1200px;
      height:447px;
      text-align: center;
      margin: 30px 0 51px 0;
      background: url("~@/assets/images/QcCashier/scene_bg.png") no-repeat center;
      background-size: 1200px 447px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px ;
      margin-top:69px;
    }
    .tool_left{
        width:228px;
        height:490px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .left_item{
            width: 228px;
            height: 76px;
            background: #DFE9FF;
            border-radius: 10px;
            font-size: 24px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 76px;
            cursor: pointer;
        }
        .left_item1{
            width: 228px;
            height: 76px;
            background: #3986FF;
            border-radius: 10px;
            font-size: 24px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 76px;
        }
    }
    .tool_right{
        width: 872px;
        height:490px;
        img{
            width: 872px;
            height:490px;
        }
    }
  }
  .scene {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .content {
      width: 1200px;
      height:447px;
      text-align: center;
      margin: 30px 0 51px 0;
      background: url("~@/assets/images/QcCashier/scene_bg1.png") no-repeat center;
      background-size: 1200px 447px;
    }
    .content1 {
      width: 1200px;
      height:435px;
      text-align: center;
      margin: 30px 0 51px 0;
      background-color:#fff;
      .content_box{
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 0 12px;
        margin-top: 50px;
        .box_item{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img{
                width: 148px;
                height: 148px;
            }
            p{
                height: 22px;
                font-size: 16px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #000000;
                line-height: 22px;
            }
        }
      }
    }
  }
}
</style>
